import { DataSourcesPage } from "../data-sources"
import { useSelection } from "@/app/department-context"
import { NoOrganizationSelected } from "@/component/no-organization-selected"

export const DataSourcesAdminPage = () => {
  const { currentOrganization: organization } = useSelection()
  if (!organization) {
    return <NoOrganizationSelected />
  }
  return <DataSourcesPage organizationId={organization.id} />
}
